import { useTranslation } from "react-i18next";

const Count = ({ props }) => {
  const { t } = useTranslation();
  const counts = props?.userProfile?.counts;

  return (
    <div className="col-md-6">
      <div className="joinings_viewBox rounded shadow-sm p-4 bg-white">
        <div>
          <h5 className="mb-4">{t("userCounts")}</h5>
          <div className="col-12">
            {counts ? (
              <div className="row mt-3 gap-3">
                <div className="col-md-5 mx-auto d-flex justify-content-center">
                  <div className="count-card text-center shadow-sm">
                    <h6 className="mb-2">{t("citizen")}</h6>
                    <p className="count-number">{counts.citizen}</p>
                  </div>
                </div>
                <div className="col-md-5 mx-auto d-flex justify-content-center">
                  <div className="count-card text-center shadow-sm">
                    <h6 className="mb-2">{t("ambassador")}</h6>
                    <p className="count-number">{counts.ambassador}</p>
                  </div>
                </div>
              </div>
            ) : (
              <p className="text-center">{t("noDataAvailable")}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Count;
